<template>
    <detail :edit-mode="false">
    </detail>
</template>

<script>
import Detail from '@/components/orders/Detail'

export default {
    name: 'CheckoutList',

    components: {
        Detail
    },

    computed: {

    },

    methods: {

    },

    created () {

    }
}
</script>
